// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__F9COV","spinner":"Loader_spinner__oivB2","spin":"Loader_spin__PTLeA"};